










import { Component, Vue, Watch } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import axios from 'axios'
import PathUtil from '../../modules/util/PathUtil'
import UidCookie from '../../modules/util/UidSetCookie'
import { SapLoginInfo } from '@/modules/util/SapUtil'

@Component
export default class Logouticon extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // computed

  get isLogin(): boolean {
    return membershipState.isLogin
  }

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private toppage = ''
  private baseUrl = '/'
  private keepPage = false
  private uidcookie = new UidCookie()

  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private beforeMount() {
    // pageで設定したkeyを取得
    this.toppage = drupalSettings.vueComponent.membershipcontroll.page.topPage
    this.keepPage =
      drupalSettings.vueComponent.membershipcontroll.logout.keepPage
    this.baseUrl = drupalSettings.path.baseUrl

    // サイトトップ 先頭は'/'にしておく
    this.toppage =
      this.toppage.slice(0, 1) === '/' ? this.toppage : '/' + this.toppage
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  private async signout() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginSignoutResponse
    })
  }

  /**
   * サインアウトコールバック
   */
  private async verifyLoginSignoutResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      const res = await axios.post(PathUtil.makePath('/member/api/logout'), {
        accountInfo: info
      })
      if (res === undefined) {
        return
      }
      const status = res.status
      if (status === 200) {
        // success logout
        // chage icon Sign in -> Sign out
        membershipState.addIsLogin(false)
        if (!this.keepPage) {
          // goto top page
          if (this.toppage === null) {
            window.location.href = this.baseUrl
          } else {
            window.location.href = this.toppage
          }
        }
      } else {
        // TODO: システムエラー
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }

  // watcher
  @Watch('isLogin')
  onIsLoginChanged(newIsLogin: boolean): void {
    // ログイン状態により、野良のログイン領域、未ログイン領域の表示状態を変更する
    const loginAreas =
      document.querySelectorAll<HTMLDivElement>('.js-showLogined')
    const unLoginAreas =
      document.querySelectorAll<HTMLDivElement>('.js-showUnlogined')
    if (newIsLogin) {
      // ログイン領域 -> 表示
      loginAreas.forEach((element) => (element.style.display = 'block'))
      // 未ログイン領域 -> 非表示
      unLoginAreas.forEach((element) => (element.style.display = 'none'))
    } else {
      // ログイン領域 -> 非表示
      loginAreas.forEach((element) => (element.style.display = 'none'))
      // 未ログイン領域 -> 表示
      unLoginAreas.forEach((element) => (element.style.display = 'block'))
    }
  }
}
